// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9367 ? "b536a0f1" : chunkId) + "." + {"3137":"195edf143a276f65","5093":"8465f0c3bb4c6010","9367":"52fab7869a25847d"}[chunkId] + ".js";
};